var map = {
	"./Elektricitet-MedVind_colour.png": 72,
	"./cat.png": 257,
	"./fejring_farve.png": 258,
	"./hjælpeløs_farve.png": 140,
	"./ladeboks.svg": 259,
	"./norlys-blad-product.png": 260,
	"./norlys-og-standard.png": 261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 256;